import { groupBuilderResponse } from "@/models/equip-api-response-objects/groupBuilderResponse";
import { userInfoResponse } from "@/models/equip-api-response-objects/userInfoResponse";
import { GetCompanyGroupData } from "@/services/api/company-endpoints";
import { FC, useEffect, useState } from "react";
import { Stack } from "@mui/material";
import React from "react";
import CoverageSection from "./coverageSection";

export default function Coverage(props: { currentUser: userInfoResponse }) {
  const [leadCoverage, setLeadCoverage] = useState<groupBuilderResponse>();
  const [coverage, setCoverage] = useState<groupBuilderResponse>();

  useEffect(() => {
    const getCoverage = async () => {
      try {
        if (props.currentUser == undefined) return;

        const myUsername = props.currentUser.userName;
        const leadCoverage = await GetCompanyGroupData(`lead=${myUsername}`);
        const coverage = await GetCompanyGroupData(`analyst=${myUsername}`);
        setLeadCoverage(leadCoverage);
        setCoverage(coverage);
      } catch (err) {
        console.error("error getting coverage", err);
      }
    };
    getCoverage();
  }, [props.currentUser]);

  return (
    <Stack spacing={2}>
      <CoverageSection
        title="Lead Coverage"
        hint={`${leadCoverage?.constituents?.length ?? 0} ${(leadCoverage?.constituents?.length ?? 0) === 1 ? "company" : "companies"}`}
        items={leadCoverage}
      />

      <CoverageSection
        title="Coverage"
        hint={`${coverage?.constituents?.length ?? 0} ${(coverage?.constituents?.length ?? 0) === 1 ? "company" : "companies"}`}
        items={coverage}
      />
    </Stack>
  );
}
